/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import type { BurgerProps, NavigationItem } from '../types';
import IconLink from '../../../atoms/icon-link/react/IconLink';
import Login from './Login';
import BurgerContentDesktop from './BurgerContentDesktop';

const BurgerContentStartTablet = ({
  setStepKey,
  setActiveItem,
  items,
  externals,
  languages,
  currentLanguage,
  loginProps,
  ministries,
  ministryDropdownName,
}: BurgerProps): React$MixedElement => {
  const handleOpen = (item: NavigationItem) => {
    setActiveItem(item);
    setStepKey('submenu');
  };

  return (
    <div className="burger__content">
      <nav className="burger__inner" aria-label={t('Detailliertes Menü')}>
        {ministries && ministries.length > 0 && (
          <button
            className="burger__select burger__select--subtle"
            onClick={() => setStepKey('ministry')}
            type="button"
          >
            {ministryDropdownName || t('Alle Ministerien')}
          </button>
        )}

        <BurgerContentDesktop items={items} />

        <div
          className="burger__secondary"
          aria-label={t('Weitere interne und externe Links und Funktionen')}
        >
          {loginProps && <Login {...loginProps} listElement={false} />}

          {currentLanguage && languages && languages.length > 0 && (
            <div className="burger__languages">
              <button
                className="burger__select"
                onClick={() => setStepKey('languages')}
                type="button"
              >
                {currentLanguage}
              </button>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default BurgerContentStartTablet;
